import {ProjectSystemType} from "../../../../../../core/model2/project/types"

const editorialCalendar = {
    "id": "Wt8scd",
    "name": "Editorial Calendar",
    "img": "/app/static/templates/marketing/calendar.jpg",
    "description": "Full-cycle content planning and execution calendar.",
    systemType: ProjectSystemType.FOLDER,
    copyToLocalTemplate: false,
    setupDemoProject: 'Marketing',
    demoFolderColor: 7
};

const eventMarketing = {
    "id": "4ffuxN",
    "name": "Event Marketing",
    "img": "/app/static/templates/marketing/event-marketing.jpg",
    "description": "Use this template to plan and execute on event marketing plan.",
    systemType: ProjectSystemType.FOLDER,
    copyToLocalTemplate: false,
    setupDemoProject: 'Marketing',
    demoFolderColor: 7
};

const campaignTracking = {
    "id": "hB3uPF",
    "name": "Campaign tracking",
    "img": "/app/static/templates/marketing/campaign-tracking.jpg",
    "description": "Use this template to track campaign performance and metrics.",
    systemType: ProjectSystemType.FOLDER,
    copyToLocalTemplate: false,
    setupDemoProject: 'Marketing',
    demoFolderColor: 7
};

const brandAssets = {
    "id": "eOxU3d",
    "name": "Brand Assets",
    "img": "/app/static/templates/marketing/brand-assets.jpg",
    "description": "Pre-configured space to organize, store, and share brand assets.",
    systemType: ProjectSystemType.FOLDER,
    copyToLocalTemplate: false,
    setupDemoProject: 'Marketing',
    demoFolderColor: 7
};

const contentManagement = {
    "id": "8L4KuJ",
    "name": "Content Management",
    "img": "/app/static/templates/marketing/content.jpg",
    "description": "Template to organize your entire content library.",
    systemType: ProjectSystemType.FOLDER,
    copyToLocalTemplate: false,
    setupDemoProject: 'Marketing',
};

const marketingPlan = {
    "id": "BBaVPK",
    "name": "Marketing Plan",
    "img": "/app/static/templates/marketing/plan.jpg",
    "description": "Quarterly marketing goals, KPIs, projects, and milestones.",
    systemType: ProjectSystemType.FOLDER,
    copyToLocalTemplate: false,
    setupDemoProject: 'Marketing',
    demoFolderColor: 7
};

const emailMarketing = {
    "id": "IqpVev",
    "name": "Email Marketing",
    "img": "/app/static/templates/marketing/email.jpg",
    "description": "The template to plan email campaigns and track performance.",
    systemType: ProjectSystemType.FOLDER,
    copyToLocalTemplate: false,
    setupDemoProject: 'Marketing',
    demoFolderColor: 7
};

const socialMedia = {
    "id": "jK0qVS",
    "name": "Social Media",
    "img": "/app/static/templates/marketing/social.jpg",
    "description": "Pre-configured social media message planner and tracker.",
    systemType: ProjectSystemType.FOLDER,
    copyToLocalTemplate: false,
    setupDemoProject: 'Marketing',
    demoFolderColor: 7
};



export default {
    id: 'marketing',
    name: "Marketing",
    items: [
        editorialCalendar,
        eventMarketing,
        campaignTracking,
        brandAssets,
        contentManagement,
        emailMarketing,
        socialMedia,
        marketingPlan,
    ]
};